import { urlGetPresmedByContract } from '../../actions/urls';
import { apiManagerRequest } from '../../axios';

const PresmedService = {
  getDataByAfilmedContract: async (contraAfilmed) => {
    const url = `${urlGetPresmedByContract}${contraAfilmed}`;
    const { data } = await apiManagerRequest.get(url);

    return data;
  },
  format: (stringNumber) => {
    // Remove leading zeroes
    return String(parseInt(stringNumber));
  },
};

export default PresmedService;
